import '../DigitalCases.css'
import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const PlataformaDeExportacao = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesDigital = [
    {
      id: 1,
      title: 'plataformaDeExportacao_page.relatedCases.items.ecommerce.title',
      description: 'plataformaDeExportacao_page.relatedCases.items.ecommerce.description',
      icon: '',
      url: 'plataforma-de-e-commerce',
    },
    {
      id: 2,
      title: 'plataformaDeExportacao_page.relatedCases.items.gestaoDePrecos.title',
      description:
        'plataformaDeExportacao_page.relatedCases.items.gestaoDePrecos.description',
      icon: '',
      url: 'plataforma-de-gestao-de-precos',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('plataformaDeExportacao_page.relatedCases.cta')

    trackCtaClick({
      cta_name: 'digital_case_related_case_click',
      cta_location: 'digital_case',
      page_name: 'plataforma_de_exportacao',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container DataCases">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('plataformaDeExportacao_page.header.title')}</h2>
        </div>
        <div className="image-container">
          <img
            src="/assets/Cases/DataCases/notebook-datacase2.png"
            alt={t('plataformaDeExportacao_page.header.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h3 className="NoBorder">
            {t('plataformaDeExportacao_page.sections.challenge.title')}
          </h3>
          <ul>
            <li>{t('plataformaDeExportacao_page.sections.challenge.items.item1')}</li>
            <li>{t('plataformaDeExportacao_page.sections.challenge.items.item2')}</li>
            <li>{t('plataformaDeExportacao_page.sections.challenge.items.item3')}</li>
            <li>{t('plataformaDeExportacao_page.sections.challenge.items.item4')}</li>
          </ul>

          <hr />

          <h3>{t('plataformaDeExportacao_page.sections.approach.title')}</h3>
          <ul>
            <li>{t('plataformaDeExportacao_page.sections.approach.items.item1')}</li>
            <li>{t('plataformaDeExportacao_page.sections.approach.items.item2')}</li>
            <li>{t('plataformaDeExportacao_page.sections.approach.items.item3')}</li>
            <li>{t('plataformaDeExportacao_page.sections.approach.items.item4')}</li>
            <li>{t('plataformaDeExportacao_page.sections.approach.items.item5')}</li>
          </ul>

          <hr />

          <h3>{t('plataformaDeExportacao_page.sections.result.title')}</h3>
          <ul>
            <li>{t('plataformaDeExportacao_page.sections.result.items.item1')}</li>
            <li>{t('plataformaDeExportacao_page.sections.result.items.item2')}</li>
            <li>{t('plataformaDeExportacao_page.sections.result.items.item3')}</li>
            <li>{t('plataformaDeExportacao_page.sections.result.items.item4')}</li>
            <li>{t('plataformaDeExportacao_page.sections.result.items.item5')}</li>
          </ul>

          {/*
          <div className="DataHashtag">
            <button>Data Engineering</button>
            <button>GEN IA</button>
            <button>Full Stack development</button>
            <button>UX</button>
          </div>
          */}
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('plataformaDeExportacao_page.relatedCases.title')}</h2>
        <span className="subtitle">
          {t('plataformaDeExportacao_page.relatedCases.subtitle')}
        </span>

        <Pagination data={casesDigital} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="icon">{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('plataformaDeExportacao_page.relatedCases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default PlataformaDeExportacao
